/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".black-overlay[_ngcontent-%COMP%]{position:absolute!important}\n/*# sourceMappingURL=crud-providers.component.css.map*/"];
export { styles as styles };
